import { Component, computed, inject, input, output, resource } from '@angular/core';
import { DataCapturingRowTypeComponent } from '../../domains/data-capturing/data-capturing-row-type/data-capturing-row-type.component';
import { CtDocument } from '@ps-gui/claims-terminal-shared';
import { TableModel } from '../../models/extraction-models/extraction-models';
import { ExtractedDataStoreService } from '../../service/extracted-data/extracted-data-store.service';
import { ExtractedRow } from '../../models/extracted-values';

@Component({
  selector: 'ct-extraction-row-classification-page',
  imports: [DataCapturingRowTypeComponent],
  templateUrl: './row-classification-page.component.html',
})
export class RowClassificationPageComponent {
  readonly currentDocument = input.required<CtDocument>();
  readonly tableModel = input.required<TableModel>();

  protected readonly currentDocumentId = computed(() => this.currentDocument().id);

  private readonly extractedDataStoreService = inject(ExtractedDataStoreService);

  protected readonly initialTableRowsByKeyResource = resource({
    params: () => ({ documentId: this.currentDocumentId() }),
    loader: async ({ params: { documentId } }) =>
      await this.extractedDataStoreService.getExtractedTables(documentId),
  });

  continue = output();

  protected saveTableValues(tableKey: string, rows: ExtractedRow[]) {
    this.extractedDataStoreService.storeExtractedRows(this.currentDocumentId(), tableKey, rows);
  }
}
